import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, Navigate, useLocation } from "react-router-dom";
import { shareMessage } from "../i18n/messages";
import { APP_HOME_PATH } from "../lib/app-paths";
import { formatTime } from "../lib/format";
import { Match } from "../types";

export const ShareLinkPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const match = (location.state as { match?: Match } | null)?.match;
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState("");

  if (!match) {
    return <Navigate to={APP_HOME_PATH} replace />;
  }

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareMessage(match));
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      setError(t("share.copyError"));
    }
  };

  const share = async () => {
    const text = shareMessage(match);
    try {
      if (navigator.share) {
        await navigator.share({ title: t("share.shareTitle"), text });
        return;
      }
      await copy();
    } catch {
      setError(t("share.shareError"));
    }
  };

  return (
    <main className="pp-screen">
      <header className="pp-header">
        <h1>{t("share.ready")}</h1>
        <p>{t("share.subtitle")}</p>
      </header>

      <section className="pp-card">
        <h2>{match.location}</h2>
        <p className="pp-muted">📅 {match.date}</p>
        <p className="pp-muted">⏰ {formatTime(match.time)}</p>
        {match.note && <p className="pp-muted">📝 {match.note}</p>}
        <p className="pp-muted" style={{ marginTop: 12 }}>
          {t("share.spotsAvailable")}
        </p>
        <p className="pp-spots">{match.spotsNeeded}</p>
      </section>

      <p className="pp-subtitle">{t("share.shareThis")}</p>
      <button type="button" className="pp-link-box" onClick={copy}>
        <span>{match.link}</span>
        <span>{copied ? "✅" : "📋"}</span>
      </button>
      <p className="pp-subtitle">{t("share.copyHintWeb")}</p>
      {error && <p className="pp-error">{error}</p>}

      <div className="pp-actions">
        <button type="button" className="pp-btn" onClick={share}>
          {t("common.share")}
        </button>
        <Link to={APP_HOME_PATH} className="pp-btn-secondary">
          {t("common.goHome")}
        </Link>
      </div>
    </main>
  );
};
